// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmListingsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AccountViewListingOptionsDto,
  AccountViewTableCellDto,
  FilterStatusType,
  ListingAlias,
  ListingPropertyUnitsResponseDto,
  ListingUnitsResponseDto,
} from '../..';

interface ApplicationsParams {
  listingAlias: ListingAlias;
}
interface LeadsParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  limit?: number;
  searchText?: string;
  startKeyExclusive?: ListingAlias;
  status?: FilterStatusType;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface UnitsParams {
  groupId: string;
  limit?: number;
  startKeyExclusive?: ListingAlias;
  status?: FilterStatusType;
}

export const RentalManagerAccountViewZrmListingsWebApiHandler_applications_Path =
  '/api/web/v2/users/accountView/zrm/listings/applications';

/**
 * Get zrm user account view unit applications count
 */
export const RentalManagerAccountViewZrmListingsWebApiHandler_applications = (
  getParams: ApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ApplicationsParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmListingsWebApiHandler_applications_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmListingsWebApiHandler_leads_Path =
  '/api/web/v2/users/accountView/zrm/listings/leads';

/**
 * Get zrm user account view unit leads count
 */
export const RentalManagerAccountViewZrmListingsWebApiHandler_leads = (
  getParams: LeadsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeadsParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmListingsWebApiHandler_leads_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmListingsWebApiHandler_list_Path =
  '/api/web/v2/users/accountView/zrm/listings/units/list';

/**
 * Get zrm user account view flat unit list
 */
export const RentalManagerAccountViewZrmListingsWebApiHandler_list = (getParams: ListParams, client = getClient()) => {
  return httpFrontEndRequest<ListParams, never, ListingUnitsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmListingsWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmListingsWebApiHandler_options_Path =
  '/api/web/v2/users/accountView/zrm/listings/options';

/**
 * Get zrm user account view flat unit row options
 */
export const RentalManagerAccountViewZrmListingsWebApiHandler_options = (
  getParams: OptionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OptionsParams, never, AccountViewListingOptionsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmListingsWebApiHandler_options_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmListingsWebApiHandler_units_Path =
  '/api/web/v2/users/accountView/zrm/listings/properties/units';

/**
 * Get zrm user account view unit list for a property
 */
export const RentalManagerAccountViewZrmListingsWebApiHandler_units = (
  getParams: UnitsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnitsParams, never, ListingPropertyUnitsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmListingsWebApiHandler_units_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
